import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { getCurrentAppData } from '../utils/fractalApps'
import UserCard from '../components/card/UserCard'
import SecurityCard from '../components/card/SecurityCard'
import { Button } from '../components/shared/styles/Button.style'

const ProfilePage = (props) => {
  const { lang } = props
  const editFormRef = useRef(null)
  const appData = getCurrentAppData()
  const { t: translation } = useTranslation()

  const handleCancel = () => {
    if (editFormRef.current?.isDirty()) {
      const confirmed = confirm(translation('profilePage')['warning'])
      if (confirmed === true && appData && appData.redirectUrl) {
        window.location.href = appData.redirectUrl
      } else {
        return null
      }
    } else if (appData && appData.redirectUrl) {
      window.location.href = appData.redirectUrl
    }
  }

  return (
    <div>
      <UserCard lang={lang} translation={translation} editFormRef={editFormRef} />

      <SecurityCard lang={lang} translation={translation} />
      <div style={{ display: 'flex', paddingLeft: '5%', width: '50%', justifyContent: 'space-around' }}>
        <Button onClick={() => editFormRef.current?.submit()} > {translation('profilePage')['saveButton']} </Button>
        <Button secondary onClick={handleCancel}> {translation('profilePage')['cancelButton']} </Button>
      </div>
    </div>
  )
}

ProfilePage.propTypes = {
  lang: PropTypes.string
}

const mapStateToProps = ({ auth }) => ({
  lang: auth.lang
})

export default connect(mapStateToProps)(ProfilePage)
